var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectedCalendars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 286 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#connected-calendars_svg__clip0_1065_288)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h95.33v122H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M8.5 0v122M0 12.5h95.33M0 81.5h95.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 21a6 6 0 016-6h78v31H17a6 6 0 01-6-6V21zM11 108a6 6 0 016-6h78v18H17a6 6 0 01-6-6v-6zM11 54a6 6 0 016-6h78v31H17a6 6 0 01-6-6V54z",
    fill: "#E0A8B9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#connected-calendars_svg__filter0_d_1065_288)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95 0h96v122H95z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M103.5 0v122M95 26.5h95.33M95 95.5h95.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 35a6 6 0 016-6h78v64h-78a6 6 0 01-6-6V35z",
    fill: "#7384D4"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#connected-calendars_svg__filter1_d_1065_288)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M191 0h95.33v122H191z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M199.5 0v122M191 38.5h95.33M191 107.5h95.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 10a6 6 0 016-6h78v32h-78a6 6 0 01-6-6V10zM202 79a6 6 0 016-6h78v49h-84V79z",
    fill: "#E17958"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "connected-calendars_svg__filter0_d_1065_288",
    x: 75,
    y: -12,
    width: 120,
    height: 146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1065_288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1065_288",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "connected-calendars_svg__filter1_d_1065_288",
    x: 171,
    y: -12,
    width: 119.33,
    height: 146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1065_288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1065_288",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "connected-calendars_svg__clip0_1065_288"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h286v122H0z"
  })))));
}
export default SvgConnectedCalendars;